import React, { useState, useEffect } from "react";
import { FieldArray, useFormikContext } from "formik";
import FormikInput from "../../Formik/FormikInput";
import FormikSelect from "../../Formik/FormikSelect";
import styled from "styled-components";
import { useLanguage } from "../../LangTranslation/LanguageContext";
import { findAndAddOption } from "../../../utilities/findAndAddOption";
import { countryChangeDefaultValues } from "../../../utilities/Validation Schema/onChangeDefaultOptions";
import useListOptions from "../../../CustomHooks/useListOptions";
import { onChangeSelectContact } from "../../../DataApi/contacts/onchangeSelectContact";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { checkApi } from "../../../DataApi/onboarding/checkApi";
import SocialMedia from "../NavtabsComponents/General/SocialMedia";
const FormContainer = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 20px;

  .form-control {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    height: 56px !important;
    font-weight: 400;
    line-height: 1.5;
    color: #4e5d78 !important;
    background-color: #f5f5f5;
    background-clip: padding-box;
    border: 1px solid #cbcbcb !important;
    border-radius: 13px !important;
  }
  *:focus {
    box-shadow: none !important;
  }
  .sales_heading {
    font-family: "Inter";
    font-weight: 600;
    font-size: 20px;
    color: "#4E5D78";
  }
  input[type="checkbox"] {
    width: 16px;
    height: 15px;
    accent-color: #ff5837;
  }
`;

const VtexGeneral = ({
  disabled,
  context,
  company_id,
  activeSocialMediaList,

  // options
  stateList,
  setStateList,
  counryList,
  setCounryList,
  currencyList,
  setCurrencyList,
  mailTemplateList,
  billingCountryList,
  setBillingCountryList,
  billingGovernateList,
  setBillingGovernateList,
  billingWilayatList,
  setBillingWilayatList,
  billingCityList,
  setBillingCityList,
  billingAreaList,
  setBillingAreaList,
  billingZipList,
  setBillingZipList,
  pickupCountryList,
  setPickupCountryList,
  pickupGovernateList,
  setPickupGovernateList,
  pickupWilayatList,
  setPickupWilayatList,
  pickupCityList,
  setPickupCityList,
  pickupAreaList,
  setPickupAreaList,
  pickupZipList,
  setPickupZipList,
}) => {
  const { setFieldValue, values } = useFormikContext();
  const { language, translations } = useLanguage();
  const { handleCustomSearch } = useListOptions();

  const t = translations[language];
  // console.log("values", values);x
  const defaultCountryOption = { label: "Oman", value: 171, phone_code: 968 };

  const optionsWithDisabledPickup = pickupCountryList.map((option) => ({
    ...option,
    isDisabled: option.value !== defaultCountryOption.value,
  }));
  const optionsWithDisabledBilling = billingCountryList.map((option) => ({
    ...option,
    isDisabled: option.value !== defaultCountryOption.value,
  }));
  // const handleChangeCountry = async (
  //   option,
  //   { name },
  //   values,
  //   setFieldValue
  // ) => {
  //   // console.log("values", values);
  //   const {
  //     state,
  //     country,
  //     currency,
  //     bank,
  //     bank_ids,
  //     active_SocialMedia_List,
  //     ...valuesWithoutExcludedKeys
  //   } = values;
  //   const modifiedBankIds = bank_ids
  //     ? bank_ids.map(({ bank, isDeleted, ...rest }) => rest)
  //     : [];
  //   if (modifiedBankIds.length > 0) {
  //     valuesWithoutExcludedKeys.bank_ids = modifiedBankIds;
  //   }

  //   const response = await onChangeSelectContact({
  //     id: [values.id],
  //     company_id,
  //     context,
  //     keyChange: "country_id",
  //     values: { ...valuesWithoutExcludedKeys, [name]: option.value },
  //     model: "res.company",
  //     defaulChange: countryChangeDefaultValues,
  //   });
  //   findAndAddOption({
  //     availableOptions: counryList,
  //     incomingOption: [option.value, option.label],
  //     setAvailableOptions: setCounryList,
  //   });
  //   const incomingValues = response?.result?.value || {};

  //   setFieldValue("state_id", incomingValues?.state_id?.[0] || false);
  //   setFieldValue(
  //     "currency_id",
  //     incomingValues?.currency_id?.[0] || values.currency_id
  //   );
  //   if (incomingValues?.currency_id) {
  //     findAndAddOption({
  //       incomingOption: incomingValues?.currency_id,
  //       setAvailableOptions: setCurrencyList,
  //     });
  //   }

  //   handleCustomSearch({
  //     model: "res.country.state",
  //     args: [["country_id", "=?", option.value]],
  //     context: { ...context },
  //     setState: setStateList,
  //     staticOptions: incomingValues?.state_id ? [incomingValues?.state_id] : [],
  //   });
  // };

  return (
    <div>
      <FormContainer className="row g-3 px-2">
        <div
          className="col-12 row me-0 pe-0"
          style={{
            border: "1px dashed rgb(203, 203, 203)",
            borderRadius: "15px",
          }}
        >
          <div className="col-12 mt-3">
            <h6 className="text-center text-secondary fw-bold">
              {t["Billing | Headquaters (HQ) Address"]}
            </h6>
          </div>
          <div className="my-3 col-md-6 col-12">
            <FormikInput
              disabled={disabled}
              name="street"
              placeholder={t["Street"]}
              data-tooltip-id="streetTooltip"
              data-tooltip-content={t["Street"] + "*"}
            />
            <ReactTooltip id="streetTooltip" type="dark" effect="solid" />
          </div>
          <div className="my-3 col-md-6 col-12">
            <FormikInput
              disabled={disabled}
              magic={true}
              type="number"
              name="phone"
              placeholder={t["Phone"]}
              data-tooltip-id="phoneTooltip"
              data-tooltip-content={t["Phone"] + "*"}
            />
            <ReactTooltip id="phoneTooltip" type="dark" effect="solid" />
          </div>
          <div className="my-3 col-md-4 col-12">
            <FormikSelect
              disabled={disabled}
              name="country_id"
              onChange={(option) => {
                checkApi({
                  endpoint: "/onboarding/governorate",
                  params: {
                    country_id: option.value,
                  },
                }).then((governates) => {
                  if (governates?.result?.result?.length > 0) {
                    const governateOp = governates?.result?.result?.map(
                      (item) => ({
                        label: item.name,
                        value: item.id,
                      })
                    );
                    setPickupGovernateList(governateOp || []);
                  }
                });
              }}
              handleSearch={({ ...args }) =>
                handleCustomSearch({
                  ...args,
                  model: "res.country",
                })
              }
              options={optionsWithDisabledPickup}
              placeholder={t["Country"]}
              data-tooltip-id="pickupcountryTooltip"
              data-tooltip-content={t["Country"] + "*"}
            />
            <ReactTooltip
              id="pickupcountryTooltip"
              type="dark"
              effect="solid"
            />
          </div>
          <div className="my-3 col-md-4 col-12">
            <FormikSelect
              disabled={disabled}
              name="governorate_id"
              onChange={(option) => {
                checkApi({
                  endpoint: "/onboarding/wilayat",
                  params: {
                    governorate_id: option.value,
                  },
                }).then((wilayats) => {
                  if (wilayats?.result?.result?.length > 0) {
                    const wilayatOp = wilayats?.result?.result?.map((item) => ({
                      label: item.name,
                      value: item.id,
                    }));
                    setPickupWilayatList(wilayatOp || []);
                  }
                });
              }}
              handleSearch={({ ...args }) =>
                handleCustomSearch({
                  ...args,
                  model: "governorate.master",
                })
              }
              options={pickupGovernateList}
              placeholder={t["Governorate"]}
              data-tooltip-id="pickupgovernateTooltip"
              data-tooltip-content={t["Governorate"] + "*"}
            />
            <ReactTooltip
              id="pickupgovernateTooltip"
              type="dark"
              effect="solid"
            />
          </div>
          <div className="my-3 col-md-4 col-12">
            <FormikSelect
              disabled={disabled}
              name="wilayat_id"
              onChange={(option) => {
                checkApi({
                  endpoint: "/onboarding/city",
                  params: {
                    wilayat_id: option.value,
                  },
                }).then((cities) => {
                  if (cities?.result?.result?.length > 0) {
                    const cityOp = cities?.result?.result?.map((item) => ({
                      label: item.name,
                      value: item.id,
                    }));
                    setPickupCityList(cityOp || []);
                  }
                });
              }}
              handleSearch={({ ...args }) =>
                handleCustomSearch({
                  ...args,
                  model: "wilayat.master",
                })
              }
              options={pickupWilayatList}
              placeholder={t["Wilayat"]}
              data-tooltip-id="pickupwilayatTooltip"
              data-tooltip-content={t["Wilayat"] + "*"}
            />
            <ReactTooltip
              id="pickupwilayatTooltip"
              type="dark"
              effect="solid"
            />
          </div>
          <div className="my-3 col-md-4 col-12">
            <FormikSelect
              disabled={disabled}
              name="city_id"
              onChange={(option) => {
                checkApi({
                  endpoint: "/onboarding/area",
                  params: {
                    city_id: option.value,
                  },
                }).then((areas) => {
                  if (areas?.result?.result?.length > 0) {
                    const areaOp = areas?.result?.result?.map((item) => ({
                      label: item.name,
                      value: item.id,
                    }));
                    setPickupAreaList(areaOp || []);
                  }
                });
              }}
              handleSearch={({ ...args }) =>
                handleCustomSearch({
                  ...args,
                  model: "city.master",
                })
              }
              options={pickupCityList}
              placeholder={t["City"]}
              data-tooltip-id="pickupcityTooltip"
              data-tooltip-content={t["City"] + "*"}
            />
            <ReactTooltip id="pickupcityTooltip" type="dark" effect="solid" />
          </div>
          <div className="my-3 col-md-4 col-12">
            <FormikSelect
              disabled={disabled}
              name="area_id"
              onChange={(option) => {
                checkApi({
                  endpoint: "/onboarding/zip",
                  params: {
                    area_id: option.value,
                  },
                }).then((zip) => {
                  if (zip?.result?.result?.length > 0) {
                    const zipBOp = zip?.result?.result?.map((item) => ({
                      label: item.name,
                      value: item.id,
                    }));
                    setPickupZipList(zipBOp || []);
                  }
                });
              }}
              handleSearch={({ ...args }) =>
                handleCustomSearch({
                  ...args,
                  model: "area.master",
                })
              }
              options={pickupAreaList}
              placeholder={t["Area"]}
              data-tooltip-id="pickupareaTooltip"
              data-tooltip-content={t["Area"] + "*"}
            />
            <ReactTooltip id="pickupareaTooltip" type="dark" effect="solid" />
          </div>
          <div className="my-3 col-md-4 col-12">
            <FormikSelect
              disabled={disabled}
              name="zip_id"
              handleSearch={({ ...args }) =>
                handleCustomSearch({
                  ...args,
                  model: "zip.master",
                })
              }
              options={pickupZipList}
              placeholder={t["Zip Code"]}
              data-tooltip-id="pickupzipTooltip"
              data-tooltip-content={t["Zip Code"] + "*"}
            />
            <ReactTooltip id="pickupzipTooltip" type="dark" effect="solid" />
          </div>
        </div>
        <div
          className="col-12 row me-0 pe-0 mt-3"
          style={{
            border: "1px dashed rgb(203, 203, 203)",
            borderRadius: "15px",
          }}
        >
          <div className="col-12 mt-3">
            <h6 className="text-center text-secondary fw-bold">
              {t["Pickup Address"]}
            </h6>
          </div>
          <div className="my-3 col-md-6 col-12">
            <FormikInput
              disabled={disabled}
              name="street2"
              placeholder={t["Street"]}
              data-tooltip-id="streetTooltip"
              data-tooltip-content={t["Street"] + "*"}
            />
            <ReactTooltip id="streetTooltip" type="dark" effect="solid" />
          </div>
          <div className="my-3 col-md-6 col-12">
            <FormikInput
              disabled={disabled}
              magic={true}
              type="number"
              name="s_phone"
              placeholder={t["Phone"]}
              data-tooltip-id="sphoneTooltip"
              data-tooltip-content={t["Phone"] + "*"}
            />
            <ReactTooltip id="sphoneTooltip" type="dark" effect="solid" />
          </div>
          <div className="my-3 col-md-4 col-12">
            <FormikSelect
              disabled={disabled}
              name="s_country_id"
              onChange={(option) => {
                setFieldValue("currency_id", 166);
                checkApi({
                  endpoint: "/onboarding/governorate",
                  params: {
                    country_id: option.value,
                  },
                }).then((governates) => {
                  if (governates?.result?.result?.length > 0) {
                    const governateOp = governates?.result?.result?.map(
                      (item) => ({
                        label: item.name,
                        value: item.id,
                        // zip: theme.zip,
                      })
                    );
                    setBillingGovernateList(governateOp || []);
                  }
                });
              }}
              handleSearch={({ ...args }) =>
                handleCustomSearch({
                  ...args,
                  model: "res.country",
                })
              }
              options={optionsWithDisabledBilling}
              placeholder={t["Country"]}
              data-tooltip-id="countryTooltip"
              data-tooltip-content={t["Country"] + "*"}
            />
            <ReactTooltip id="countryTooltip" type="dark" effect="solid" />
          </div>
          <div className="my-3 col-md-4 col-12">
            <FormikSelect
              disabled={disabled}
              name="s_governorate_id"
              onChange={(option) => {
                checkApi({
                  endpoint: "/onboarding/wilayat",
                  params: {
                    governorate_id: option.value,
                  },
                }).then((wilayats) => {
                  if (wilayats?.result?.result?.length > 0) {
                    const wilayatOp = wilayats?.result?.result?.map((item) => ({
                      label: item.name,
                      value: item.id,
                    }));
                    setBillingWilayatList(wilayatOp || []);
                  }
                });
              }}
              handleSearch={({ ...args }) =>
                handleCustomSearch({
                  ...args,
                  model: "governorate.master",
                })
              }
              options={billingGovernateList}
              placeholder={t["Governorate"]}
              data-tooltip-id="governateTooltip"
              data-tooltip-content={t["Governorate"] + "*"}
            />
            <ReactTooltip id="governateTooltip" type="dark" effect="solid" />
          </div>
          <div className="my-3 col-md-4 col-12">
            <FormikSelect
              disabled={disabled}
              name="s_wilayat_id"
              onChange={(option) => {
                checkApi({
                  endpoint: "/onboarding/city",
                  params: {
                    wilayat_id: option.value,
                  },
                }).then((cities) => {
                  if (cities?.result?.result?.length > 0) {
                    const cityOp = cities?.result?.result?.map((item) => ({
                      label: item.name,
                      value: item.id,
                    }));
                    setBillingCityList(cityOp || []);
                  }
                });
              }}
              handleSearch={({ ...args }) =>
                handleCustomSearch({
                  ...args,
                  model: "wilayat.master",
                })
              }
              options={billingWilayatList}
              placeholder={t["Wilayat"]}
              data-tooltip-id="wilayatTooltip"
              data-tooltip-content={t["Wilayat"] + "*"}
            />
            <ReactTooltip id="wilayatTooltip" type="dark" effect="solid" />
          </div>
          <div className="my-3 col-md-4 col-12">
            <FormikSelect
              disabled={disabled}
              name="s_city_id"
              onChange={(option) => {
                checkApi({
                  endpoint: "/onboarding/area",
                  params: {
                    city_id: option.value,
                  },
                }).then((areas) => {
                  if (areas?.result?.result?.length > 0) {
                    const areaOp = areas?.result?.result?.map((item) => ({
                      label: item.name,
                      value: item.id,
                    }));
                    setBillingAreaList(areaOp || []);
                  }
                });
              }}
              handleSearch={({ ...args }) =>
                handleCustomSearch({
                  ...args,
                  model: "city.master",
                })
              }
              options={billingCityList}
              placeholder={t["City"]}
              data-tooltip-id="cityTooltip"
              data-tooltip-content={t["City"] + "*"}
            />
            <ReactTooltip id="cityTooltip" type="dark" effect="solid" />
          </div>
          <div className="my-3 col-md-4 col-12">
            <FormikSelect
              disabled={disabled}
              name="s_area_id"
              onChange={(option) => {
                checkApi({
                  endpoint: "/onboarding/zip",
                  params: {
                    area_id: option.value,
                  },
                }).then((zip) => {
                  if (zip?.result?.result?.length > 0) {
                    const zipBOp = zip?.result?.result?.map((item) => ({
                      label: item.name,
                      value: item.id,
                    }));
                    setBillingZipList(zipBOp || []);
                  }
                });
              }}
              handleSearch={({ ...args }) =>
                handleCustomSearch({
                  ...args,
                  model: "area.master",
                })
              }
              options={billingAreaList}
              placeholder={t["Area"]}
              data-tooltip-id="areaTooltip"
              data-tooltip-content={t["Area"] + "*"}
            />
            <ReactTooltip id="areaTooltip" type="dark" effect="solid" />
          </div>
          <div className="my-3 col-md-4 col-12">
            <FormikSelect
              disabled={disabled}
              name="s_zip_id"
              handleSearch={({ ...args }) =>
                handleCustomSearch({
                  ...args,
                  model: "zip.master",
                })
              }
              options={billingZipList}
              placeholder={t["Zip Code"]}
              data-tooltip-id="zipTooltip"
              data-tooltip-content={t["Zip Code"] + "*"}
            />
            <ReactTooltip id="zipTooltip" type="dark" effect="solid" />
          </div>
        </div>
        <div className="col-12">
          <FormikInput
            disabled={disabled}
            type="email"
            name="email"
            label={t["Email"]}
          />
        </div>
        <div className="col-md-6">
          <FormikSelect
            disabled={disabled}
            name="currency_id"
            options={currencyList}
            placeholder={t["Currency"]}
            label={t["Currency"]}
            handleSearch={({ ...args }) =>
              handleCustomSearch({
                ...args,
                model: "res.currency",
                context: { ...context, active_test: false },
              })
            }
          />
        </div>

        <div className="col-md-6">
          <FormikInput
            disabled={disabled}
            type="char"
            label={t["Website Link"]}
            name="website"
          />
        </div>
        <div className="col-md-6">
          <FormikInput
            disabled={disabled}
            type="number"
            name="vat"
            label={t["Tax ID"]}
          />
        </div>
        <div className="col-md-6">
          <FormikInput
            disabled={disabled}
            type="text"
            name="company_registry"
            label={t["Company Registry"]}
          />
        </div>
      </FormContainer>
    </div>
  );
};

export default VtexGeneral;
